<template>
  <div
    class="description-row"
    @keydown.tab.stop.prevent
    @keydown.enter.stop.prevent
  >
    <EditorDisplay
      :key="`comment-editor-${comment.id}`"
      :resource-id="resourceId"
      :resource-type="resourceType"
      :class="{ 'mt-2': isPage }"
      class="description-text text-sm"
      :content="comment.content"
      :display-sticky="false"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'CommentListItemDescriptionRow',
  components: {
    EditorDisplay: defineAsyncComponent(
      () => import(/* webpackChunkName: 'Editor' */ '@/components/editor/EditorDisplay')
    ),
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
    resourceId: {
      type: String,
      required: false,
      default: '',
    },
    resourceType: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    isPage() {
      return this.$route.name === 'page' ?? !this.$store.getters.getCurrentPageID;
    },
  },
};
</script>

<style lang="scss">
.description-row {
  @apply overflow-hidden
    px-[0.5rem]
    pt-[5px]
    pb-[1rem]
    border-solid
    border
    border-x-0
    border-transparent;

  .description-text {
    position: relative;
    height: 100%;
    letter-spacing: 0px;
    overflow-wrap: break-word;
    @apply text-text-default flex flex-col;

    p {
      min-height: 20px;
    }

    .code-block {
      pre {
        font-size: 14px !important;
      }
    }

    .st-editor-content {
      * {
        line-height: 20px;
      }
    }
  }

  .st-editor-content {
    @apply p-0;
  }

  .beautified-link {
    &--link-icon {
      width: 14px !important;
      height: 14px !important;
    }

    .emoji-icon {
      font-size: 14px !important;
    }
  }
}
</style>
